// @generated by protoc-gen-connect-es v1.6.1 with parameter "target=ts"
// @generated from file calendar/v1/service.proto (package calendar.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { DisableIcalSubscriptionRequest, DisableIcalSubscriptionResponse, EnableIcalSubscriptionRequest, EnableIcalSubscriptionResponse, GetIcalSubscriptionUrlRequest, GetIcalSubscriptionUrlResponse } from "./service_pb.js";
import { MethodIdempotency, MethodKind } from "@bufbuild/protobuf";

/**
 * The following error codes are not stated explicitly in the each rpc, but may be returned.
 *   - shared.InvalidArgument
 *   - shared.Unauthenticated
 *   - shared.Unauthorized
 *
 * @generated from service calendar.v1.CalendarService
 */
export const CalendarService = {
  typeName: "calendar.v1.CalendarService",
  methods: {
    /**
     * @generated from rpc calendar.v1.CalendarService.GetIcalSubscriptionUrl
     */
    getIcalSubscriptionUrl: {
      name: "GetIcalSubscriptionUrl",
      I: GetIcalSubscriptionUrlRequest,
      O: GetIcalSubscriptionUrlResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * @generated from rpc calendar.v1.CalendarService.EnableIcalSubscription
     */
    enableIcalSubscription: {
      name: "EnableIcalSubscription",
      I: EnableIcalSubscriptionRequest,
      O: EnableIcalSubscriptionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc calendar.v1.CalendarService.DisableIcalSubscription
     */
    disableIcalSubscription: {
      name: "DisableIcalSubscription",
      I: DisableIcalSubscriptionRequest,
      O: DisableIcalSubscriptionResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

